<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    centered
    :ok-title="uploading ? 'Uploading…' : 'Upload'"
    cancel-title="Cancel"
    :ok-disabled="!file || uploading"
    :cancel-disabled="uploading"
    :no-close-on-backdrop="uploading"
    :no-close-on-esc="uploading"
    @ok="onOk"
    @hidden="reset"
  >
    <p v-if="requirement" class="mb-1">
      <strong>{{ requirement.Name }}</strong>
      <small v-if="requirement.Note" class="text-muted d-block">{{ requirement.Note }}</small>
      <small v-if="requirement.PersonName" class="text-muted d-block">For: {{ requirement.PersonName }}</small>
    </p>
    <p v-else class="text-muted mb-1">
      Upload any additional document you would like to share with Swiss Finance Corporation.
    </p>

    <b-form-group label="File *">
      <b-form-file
        v-model="file"
        placeholder="Choose a file or drop it here…"
        drop-placeholder="Drop the file here…"
        :disabled="uploading"
      />
    </b-form-group>

    <b-form-group label="Note (optional)">
      <b-form-textarea v-model="note" rows="2" placeholder="Anything we should know about this document" :disabled="uploading" />
    </b-form-group>

    <b-alert :show="!!error" variant="danger" class="p-50 mb-0">{{ error }}</b-alert>
  </b-modal>
</template>

<script>
// File + optional note. POSTs multipart {file, requirementId?, note?} and emits the
// full page payload returned by the server (`uploaded`).
import { uploadDocument, errorMessage } from "./publicApi";

export default {
  name: "UploadNoteModal",

  data() {
    return {
      requirement: null,
      file: null,
      note: "",
      uploading: false,
      error: null,
    };
  },

  computed: {
    modalTitle() {
      if (!this.requirement) return "Upload a document";
      return this.requirement.CurrentDocument ? "Replace document" : "Upload document";
    },
  },

  methods: {
    // requirement: a requirement row, or null for a free extra upload
    open(requirement) {
      this.requirement = requirement || null;
      this.file = null;
      this.note = "";
      this.error = null;
      this.$refs.modal.show();
    },

    reset() {
      this.requirement = null;
      this.file = null;
      this.note = "";
      this.error = null;
      this.uploading = false;
    },

    // keep the modal open while the upload runs; it is closed from submit()
    onOk(event) {
      if (event && typeof event.preventDefault === "function") event.preventDefault();
      this.submit();
    },

    submit() {
      if (!this.file || this.uploading) return;
      this.uploading = true;
      this.error = null;

      uploadDocument({
        file: this.file,
        requirementId: this.requirement ? this.requirement.id : null,
        note: this.note.trim() || null,
      })
        .then((res) => {
          this.$bvToast.toast(res.data.message || "Document uploaded. Thank you.", {
            title: "Uploaded",
            variant: "success",
            solid: true,
          });
          this.$emit("uploaded", res.data);
          this.uploading = false;
          this.$refs.modal.hide();
        })
        .catch((err) => {
          this.uploading = false;
          this.error = errorMessage(err, "Upload failed. Please try again.");
        });
    },
  },
};
</script>
